"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { ForumRoutedPage } from './deskUi/ForumRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function ForumSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={ForumRoutedPage} Loading={MsgDeskLoading} />
}
